import { Option } from '../../general-types';
import { ValueOfKey } from '../../utils-types';

export const CORPORATION_TYPE = {
  LLC_SOLE_PROPRIETORSHIP: 'LLC_SOLE_PROPRIETORSHIP',
  CO_OPERATIVE: 'CO_OPERATIVE',
  CORPORATION: 'CORPORATION',
  NON_PROFIT_CORPORATION: 'NON_PROFIT_CORPORATION',
  PARTNERSHIP: 'PARTNERSHIP',
} as const;

export type CorporationType = ValueOfKey<typeof CORPORATION_TYPE>;

export const corporationTypeOptions: Option<CorporationType>[] = [
  { label: 'LLC/Sole proprietorship', value: 'LLC_SOLE_PROPRIETORSHIP' },
  { label: 'Co-Operative', value: 'CO_OPERATIVE' },
  { label: 'Corporation', value: 'CORPORATION' },
  { label: 'Non-Profit Corporation', value: 'NON_PROFIT_CORPORATION' },
  { label: 'Partnership', value: 'PARTNERSHIP' },
];
